import { ContentWrapper } from 'src/components/common/wrapper/content/wrapper';
import { FilterWrapper } from 'src/components/common/wrapper/filter/wrapper';
import {
  Actions,
  AppArea,
  Subjects,
  UserGroupListFilterInput,
} from 'src/graphql/generated/graphql';
import { useUserGroups } from 'src/hooks/query/user-groups/use-user-groups';
import { useTable } from 'src/hooks/use-table';
import { UserGroupsTable } from './table';
import { TableWrapper } from 'src/components/common/wrapper/table/wrapper';
import { Filter } from './filter';
import { useNavigate } from 'react-router-dom';
import { Routes } from 'src/components/common/router/constants';
import { Button } from '@otp/ui';
import { useTranslation } from 'react-i18next';
import { Can } from 'src/utils/can';
import { DeploymentPartnerUserGroupsReportButton } from './deployment-partner-user-groups-report-button';

const PAGINATION_LIMIT = 10;

export const UserGroupList = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { page, setPage, filter, onFilterChange, defaultFilter } = useTable<
    UserGroupListFilterInput,
    Record<any, any>
  >({ defaultFilter: { isDisabled: false } });

  const { loading, data, totalCount } = useUserGroups({
    filter,
    pagination: {
      page,
      limit: PAGINATION_LIMIT,
    },
  });

  const onCreate = () => {
    navigate(`${Routes.userGroups.path}/create`);
  };

  return (
    <>
      <Can I={Actions.Read} a={Subjects.UserGroups} appArea={AppArea.Admin}>
        <FilterWrapper>
          <Filter onSubmit={onFilterChange} defaultFilter={defaultFilter} />
        </FilterWrapper>

        <ContentWrapper>
          <TableWrapper>
            {/* TODO: Wrap into own component */}
            <Can
              I={Actions.Write}
              a={Subjects.UserGroups}
              appArea={AppArea.Admin}
            >
              <div className="flex justify-end gap-2">
                <DeploymentPartnerUserGroupsReportButton />
                <Button variant="contained" onClick={onCreate}>
                  {t('user-group.list.create-button')}
                </Button>
              </div>
            </Can>
            <UserGroupsTable
              data={data}
              className="mt-4"
              loading={loading}
              options={{
                page,
                count: totalCount,
                sort: true,
                rowsPerPage: PAGINATION_LIMIT,
                onChangePage: setPage,
                enableNestedDataAccess: '.',
              }}
            />
          </TableWrapper>
        </ContentWrapper>
      </Can>
    </>
  );
};
